// src/features/patient/human-review/reviewActionLabels.ts

/**
 * Purpose : Every button name of the review queues and the review form, in one
 *           place, so the same situation always reads the same for every kind
 *           of item (medicine, record, identity) and on every screen.
 *
 * Contents :
 *
 * * const(ACTION_LABELS) : the button names
 */


// const(ACTION_LABELS)
/**
 * Every button name in the queues, in one place: the same situation always
 * reads the same, whatever kind of item it is (medicine, record, identity).
 */
export const ACTION_LABELS = {
  review: "Review",
  reply: "Reply",
  skip: "Skip, let a clinician decide",
  /** The review form's send button when the answer goes to a clinician. */
  send: "Send to my clinician",
  /** Reviewed, still open: change the answer or add to it. */
  update: "Update your answer",
  /** Skipped (or moved on unanswered), still open: answer late. */
  answer: "Add your answer",
  /** An identity check the system settled from another "Yes": undo it (the
   *  upload is taken out of the records and the golden records are worked out
   *  again; the patient then picks Delete upload or Keep hidden). */
  notYou: "Remove from my records",
} as const;
